import TelefoneAdministrativoModel from '@/models/cadastros/assistencia/TelefoneAdministrativoModel';
import EnderecoAdministrativoModel from '@/models/cadastros/assistencia/EnderecoAdministrativoModel';
import LocalidadeModel from "@/models/cadastros/assistencia/geolocalizacao/LocalidadeModel";

export default class  ClienteAdministrativoModel {
    id?: number;
    nome?: string;
    cpfCnpj?: string;
    frota?: boolean;
    kmGuinchoContratado?: number;
    email?: string;
    endereco?: LocalidadeModel;
    telefones?:TelefoneAdministrativoModel[];
    telefone?: string;
    descricaoCompleta?: string;
}